/**
 * Prevents opening context menu via right-click.
 *
 * Usage: set element with `data-prevent-context-menu`.
 */
document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("contextmenu", (event) => {
    if (event.target.matches("[data-prevent-context-menu]")) {
      event.preventDefault();
    }
  });
});
